angular.module('rjmNg.directives').directive "googleConnectionEditor", [
  () ->
    restrict: "E"
    templateUrl: "connectionEditors/google.html"
    scope: {}
    require: "^?rjmUi"
    controller: [
      "$scope"
      "$q"
      "$routeParams"
      "$timeout"
      "ConnectionMeta"
      "Google"
      "app"
      "$clientUrl"
      "$clientAppUrl"
      "$modal"
      "InputConnections"
      "notification"
      "FEATURE_TIER"
      (
        $scope
        $q
        $routeParams
        $timeout
        ConnectionMeta
        Google
        app
        $clientUrl
        $clientAppUrl
        $modal
        InputConnections
        notification
        FEATURE_TIER
      ) ->
        $scope.authorizationUrl = null
        $scope.connectionsPageUrl = $clientAppUrl('/settings/connection/')

        $scope.updateAuthorizationUrl = () ->
          $scope.authorizationUrl = $clientUrl("/google/authorize?feature=#{$scope.feature}&connectionIdToReauth=#{$scope.connectionId}")

        $scope.connectionId = if $routeParams.connectionId then $routeParams.connectionId else null
        $scope.connectionIdToReauth = if $routeParams.connectionIdToReauth then $routeParams.connectionIdToReauth else null
        relatedConnectionIdsToReauth = null
        $scope.step = 1
        $scope.profileName = ""
        $scope.isLoading = false
        $scope.isGA4 = false

        $scope.shouldHideGAPicker = false

        authErrorMessagen = "We are unable to set up authorization with Google."
        tokenErrorMessage = "We are unable to authorize your account."
        getProfilesErrorMessage = "We are unable to get repeat authorization for your account."
        unsavedConnectionErrorMessage = "An error occurred saving the connection."
        loadConnectionErrorMessage = "An error occurred loading the connection."

        clientId = $routeParams.clientId
        GoogleInstance = Google(clientId)
        InputConnectionsInstance = InputConnections(clientId)

        $scope.saveConnection = (profile, token) ->
          profile.tracked = true
          $scope.isLoading = true
          name = if $scope.isGA4 then GoogleInstance.getGA4ConnectionName(profile, $scope.feature) else GoogleInstance.getConnectionName(profile, $scope.feature)

          savedConnection = ({data}) ->
            notification.clear('google-connection')
            notification.success("Success.", "Saved profile to a connection named: #{name}. <a href='#{$scope.connectionsPageUrl}'>Go Back to Integrations List</a>", "google-connection")
            $scope.isLoading = false
            $scope.shouldHideGAPicker = app.getFeatureTier() is FEATURE_TIER.BASIC
            $scope.$broadcast("googleConnectionSaved", data.id)

          didntSaveConnection = ->
            profile.tracked = false
            notification.clear('google-connection')
            notification.error("Error.", unsavedConnectionErrorMessage, "google-connection")
            $scope.isLoading = false

          testPassed = ->
            $scope.isLoading = true
            GoogleInstance.save(
              name: name
              token: token
              profileId: if $scope.isGA4 then profile.property else profile.id
              feature: $scope.feature
              connectionIdToReauth: $scope.connectionIdToReauth
              relatedConnectionIdsToReauth: relatedConnectionIdsToReauth
              webPropertyId: if $scope.isGA4 then profile.parent else profile.id
            ).then(savedConnection, didntSaveConnection)

          cancelSave = ->
            profile.tracked = false
            $scope.isLoading = false

          testFailed = ->
            # tell the googleProfilePicker to stop waiting
            $scope.$broadcast("googleConnectionTestFailed")
            $scope.isLoading = false
            $modalScope = $scope.$new()

            supportArticle =
              Analytics4Live:
                url: "https://rjmetrics.zendesk.com/hc/en-us/articles/204675135-Connect-your-Google-Analytics-account"
                title: 'Connect Your Google Analytics Account'
              Analytics:
                url: "https://rjmetrics.zendesk.com/hc/en-us/articles/204675135-Connect-your-Google-Analytics-account"
                title: 'Connect Your Google Analytics Account'
              Ecommerce:
                url: 'https://rjmetrics.zendesk.com/hc/en-us/articles/204675225-Track-order-acquisition-source-via-Google-eCommerce'
                title: 'Track Order Acquisition Source Via Google ECommerce'
              AdWords:
                url: 'https://rjmetrics.zendesk.com/hc/en-us/articles/204675175-Connect-your-ad-spend-data-Google-Adwords'
                title: 'Connect Your Ad Spend Data: Google Adwords'

            $modalScope.feature = $scope.feature
            $modalScope.confirmSave = testPassed
            $modalScope.cancelSave = cancelSave
            $modalScope.supportUrl = supportArticle[$scope.feature].url
            $modalScope.supportTitle = supportArticle[$scope.feature].title

            modal = $modal
              template: 'settings/modal.connectionTestFailed.html'
              show: true
              backdrop: 'static'
              persist: false
              scope: $modalScope
              modalClass: 'rj-modal'

          GoogleInstance.testConnection(
            token: token
            profileId: if $scope.isGA4 then profile.property else profile.id
            feature: $scope.feature
          ).then (response) ->
            if response.data.containsRows
              testPassed()
            else
              testFailed()
          , testFailed

        $scope.pickProfiles = false
        $scope.profileList = []

        pickProfiles = ([connections, profiles]) ->
          $scope.isLoading = false
          $scope.pickProfiles = true

          if $scope.isGA4
            profiles = profiles.data?.accountSummaries
            ga4profiles = []
            if profiles != undefined and profiles.length != 0
              for account in profiles
                if account.propertySummaries != undefined and account.propertySummaries.length != 0
                  for property in account.propertySummaries
                    property.accountName = account.displayName
                    property.id = property.property
                    ga4profiles.push property
              profiles = ga4profiles
          else
            profiles = profiles.data?.items 


          if profiles is undefined or profiles.length is 0
            $scope.profileList = []
            notification.error("Error.", "There are no Google #{$scope.feature} profiles associated with this account. Please make sure that the user you are connecting to Google #{$scope.feature} with has the appropriate permissions associated with it. For further assistance, please contact support.", "google-connection")
            return

          # mark tracked profiles
          trackedProfileIds = []
          trackedConnectionIds = []
          for connection in connections
            if connection.type in ["google_analytics", "googleanalytics", "google_analytics4_live"] and connection.properties.feature is $scope.feature.toLowerCase()
              trackedProfileIds.push connection.properties.profile_id
              trackedConnectionIds.push connection.meta_id

          for profile in profiles
            if profile.id in trackedProfileIds
              profile.tracked = true

          if $routeParams.connectionIdToReauth?
            connection = (connection for connection in connections when connection.meta_id is parseInt($routeParams.connectionIdToReauth))[0]
            profiles = (profile for profile in profiles when (profile?.id is connection.properties.profile_id?.toString()) or (profile?.id is connection.properties.profile_id?.toString()))

            if profiles.length is 0
              notification.error("Error.", "The account you selected does not have access to this Google #{$scope.feature} profile. Please make sure that the user you are re-authorizing your Google #{$scope.feature} connection with has the appropriate permissions to access this account. For further assistance, please contact support.", "google-connection")
              return

            relatedConnectionIdsToReauth = (connectionId for connectionId in trackedConnectionIds when connectionId isnt parseInt($routeParams.connectionIdToReauth))
            notification.success("Success.", "Successfully re-authorized your Google #{$scope.feature} connection! Please wait for the connection to save before navigating away from this page.", "google-connection")
          else
            notification.success("Success.", "Connected successfully! Please select the profiles you wish to track below.", "google-connection")

          $scope.profileList = profiles

        getProfiles = (response) ->
          $scope.refresh_token = response.data?.refresh_token
          access_token = response.data?.access_token

          $q.all([
              InputConnectionsInstance.get(),
              if $scope.isGA4 
                GoogleInstance.getGA4ProfileIds(access_token)
              else 
                GoogleInstance.getProfileIds(access_token)
          ])

        showErrorMessageFactory = (message) ->
          (response) ->
            deferred = $q.defer()
            # don't show the second error message for the first error
            if response != "earlierError"
              $scope.isLoading = false
              notification.clear('google-connection')
              notification.error("Error.", message, "google-connection")
            deferred.reject("earlierError")
            return deferred.promise

        $scope.loadConnection = (connectionId) ->
          $scope.step = 2
          ConnectionMeta(clientId).connection(connectionId).then(({data}) ->
            if data.id
              feature = data.meta.connection.feature
              # Keep it backwards compatible with OAuth1 GA connections
              if not feature and data.meta.connection.type is "google_analytics"
                feature = "Analytics"
              if feature.toLowerCase() == "adwords"
                $scope.feature = "AdWords"
              if feature.toLowerCase() == "adwords-custom"
                $scope.feature = "AdWords"
              else if feature.toLowerCase() == "ecommerce"
                $scope.feature = "Ecommerce"
              else if feature.toLowerCase() == "analytics"
                $scope.feature = "Analytics"
              else if feature.toLowerCase() == "analytics4live"
                $scope.feature = "Analytics4Live"

              $scope.profileName = data.meta.name
              $scope.isLoading = false
          ).catch(showErrorMessageFactory(loadConnectionErrorMessage))

        reauthorizeConnection = (profiles) ->
          if profiles?
           $scope.saveConnection(profiles[0], $scope.refresh_token)

        initialize = () ->
          notification.clear('google-connection')
          $scope.isGA4 = $scope.feature == "Analytics4Live"
          unless $routeParams.error? 
            if $routeParams.connectionIdToReauth?
              GoogleInstance.getAccessToken($routeParams.code, $scope.feature)
                .then(getProfiles, showErrorMessageFactory(tokenErrorMessage))
                .then(pickProfiles, showErrorMessageFactory(getProfilesErrorMessage))
                .then(reauthorizeConnection, showErrorMessageFactory(unsavedConnectionErrorMessage))
            else if $routeParams.code?
              GoogleInstance.getAccessToken($routeParams.code, $scope.feature)
                .then(getProfiles, showErrorMessageFactory(tokenErrorMessage))
                .then(pickProfiles, showErrorMessageFactory(getProfilesErrorMessage))
            else if $routeParams.connectionId
              $scope.loadConnection($routeParams.connectionId)

        if $routeParams.error?
          notification.error("Error.", authErrorMessage, "google-connection")
        else if $routeParams.feature? or $routeParams.connectionId?
          $scope.isLoading = true
          $scope.feature = $routeParams.feature

        initialize()

        @saveConnection = $scope.saveConnection

        @

    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "isLoading", () ->
        rjmUi?.loadingUi "google-connection-editor", scope.isLoading

      scope.$watchGroup ['connectionId', 'feature'], scope.updateAuthorizationUrl

]
